// Contact App JavaScript Bundle
// This file serves as the entry point for all contact-app specific functionality

import { initializeApplication } from '../index';

const moduleLoaders = {
    processing: () => import('./processing'),
    'capitalize-input': () => import('./capitalize-input'),
    'checkbox-confirmation': () => import('./checkbox-confirmation'),
    'conditional-select': () => import('./conditional-select'),
    'disable-button-attachment': () => import('./disable-button-attachment-screen'),
};

initializeApplication();

document.addEventListener('DOMContentLoaded', async () => {
    const modules = document.querySelectorAll('[data-ca-module]');
    const promises = Array.from(modules).map(async (element) => {
        const moduleNames = element.dataset.caModule.split(',').map((name) => name.trim());
        return Promise.all(
            moduleNames.map(async (moduleName) => {
                const loader = moduleLoaders[moduleName];
                if (loader) {
                    const module = await loader();
                    module.default();
                }
            })
        );
    });
    await Promise.all(promises);
});
